module.exports = __webpack_public_path__ + "img/Users.068e762f.svg";